module.exports = __webpack_public_path__ + "img/sundrymarket_logo.075402dd.jpg";